import React, { useMemo } from "react";

import { useIntl } from "react-intl";

import { THIRD_PARTIES } from "Constants/integrationThirdParties";
import Button from "ds/Button";
import { observabilitySuitIntegrationForms } from "src/organization/pages/project/settings/integrations/components/IntegrationForm/helper";
import IntegrationIcon from "src/organization/pages/project/settings/integrations/components/IntegrationIcon";

import * as S from "./Header.styles";

import type { Integration } from "@packages/client";

type HeaderProps = {
  integration: Integration;
};

const Header = ({ integration }: HeaderProps) => {
  const intl = useIntl();

  const hasEditConfig = useMemo(
    () =>
      THIRD_PARTIES.find(c => c.type === integration.type) ||
      integration.type in observabilitySuitIntegrationForms,
    [integration.type]
  );

  return (
    <S.Wrapper>
      <S.Flex>
        <IntegrationIcon type={integration.type} />
        <S.Title tag="h2">
          {intl.formatMessage({
            id: `integration.type.${integration.type}`,
            defaultMessage: integration.type
          })}
        </S.Title>
      </S.Flex>
      {hasEditConfig && integration._links?.["#edit"] && (
        <Button
          variant="outline"
          analyticId="edit"
          to={`${location.pathname}/configure`}
        >
          {intl.formatMessage({
            id: "edit",
            defaultMessage: "Edit"
          })}
        </Button>
      )}
    </S.Wrapper>
  );
};

export default Header;
